"use client";

import type { ComponentPropsWithRef } from "react";
import useSWR from "swr";
import { getProductsAction } from "@/actions/admin";
import { FancyMultiSelect } from "../fancy-multi-select";

export const ProductMultiSelect = ({
	value,
	defaultValue,
	onValueChange,
	...props
}: Omit<
	ComponentPropsWithRef<typeof FancyMultiSelect>,
	"allSelectables" | "value" | "defaultValue" | "onValueChange"
> & {
	value?: string[];
	defaultValue?: string[];
	onValueChange?: (value: string[]) => void;
}) => {
	const { data: products } = useSWR("getProductsAction", () => getProductsAction(), {
		keepPreviousData: true,
	});

	const matchedValue = (value ?? defaultValue ?? [])
		.map((v) => products?.data?.find((c) => c.id === v))
		.filter(Boolean)
		.map((c) => ({
			value: c.id,
			label: c.name,
			image: c.images?.[0], // Use first image as thumbnail
		}));
	const allSelectables =
		products?.data?.map((c) => ({
			value: c.id,
			label: c.name,
			image: c.images?.[0], // Use first image as thumbnail
		})) ?? [];

	return (
		<FancyMultiSelect
			key={products?.data?.length}
			{...props}
			allSelectables={allSelectables}
			defaultValue={defaultValue && matchedValue}
			value={value && matchedValue}
			onValueChange={(v) => onValueChange?.(v.map((v) => v.value))}
		/>
	);
};
